var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.title))]),_c('b-table',{attrs:{"items":_vm.commodities,"fields":_vm.fields,"fixed":"","outlined":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }